import React, { useEffect, useMemo, useState } from 'react';
import SidebarMenu from '../components/SidebarMenu';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { formatDateTimeTR } from '../utils/filter_lib';
import LeaveFormModal from '../components/LeaveFormModal';
import api from '../services/api';
import { toast } from 'react-toastify';
import LeaveTypeGuidelines from '../components/LeaveTypeGuidelines';

function LeavesPage() {
  const [leaves, setLeaves] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [formModalVisible, setFormModalVisible] = useState(false);

  useEffect(() => {
    fetchLeaves();
    fetchLeaveTypes();
  }, []);

  const fetchLeaves = async () => {
    const res = await api.get('/leave-requests');
    setLeaves(res.data);
  };

  const fetchLeaveTypes = async () => {
    const res = await api.get('/leave-requests/leave-types');
    setLeaveTypes(res.data);
  };

  const leaveTypeOptions = useMemo(
    () => leaveTypes.map((lt) => ({ label: lt.name, value: lt.id })),
    [leaveTypes]
  );

  const handleSubmit = async (data) => {
    try {
      await api.post('/leave-requests', {
        ...data,
        start_date: data.start_date.toISOString(),
        end_date: data.end_date.toISOString(),
      });
      setFormModalVisible(false);
      fetchLeaves();
    } catch (error) {
      if (error?.response?.status === 422) {
        throw error;
      }
      const message = error.response?.data?.detail || 'İzin eklenemedi.';
      toast.error(message);
    }
  };

  const header = (
    <div className="flex justify-between align-items-center">
      <h3>İzin Talepleri</h3>
      <Button label="İzin Talebi Ekle" icon="pi pi-plus" onClick={() => setFormModalVisible(true)} />
    </div>
  );

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <DataTable
          value={leaves}
          header={header}
          paginator
          rows={20}
          stripedRows
          filterDisplay="row"
        >
          <Column field="user.first_name" header="Ad" body={(row) => `${row.user?.first_name} ${row.user?.last_name}`} />
          <Column field="reason" header="Açıklama" />
          <Column body={(rowData) => formatDateTimeTR(rowData.start_date)} header="Başlangıç" />
          <Column body={(rowData) => formatDateTimeTR(rowData.end_date)} header="Bitiş" />
          <Column field="manager_notes" header="Red Sebebi" />
          <Column field="leave_type.name" header="İzin Tipi" />
          <Column field="status" header="Durum" />
        </DataTable>

        <LeaveFormModal
          visible={formModalVisible}
          onHide={() => setFormModalVisible(false)}
          onSubmit={handleSubmit}
          leaveTypes={leaveTypes}
          leaveTypeOptions={leaveTypeOptions}
        />

        <LeaveTypeGuidelines leaveTypes={leaveTypes} />
      </main>
    </div>
  );
}

export default LeavesPage;
